import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./SignatureDelegation.css";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from "react";
import SignatureDelegationService from "../../services/SignatureDelegationService";
import { ArrowIcon } from "../../components/SvgComponents/ArrowIcon/ArrowIcon";
import { CancelIcon } from "../../components/SvgComponents/CancelIcon/CancelIcon";
import { Back } from "../../components/Back/Back";
import { getEvidenceData } from "../../util/getEvidenceData";


export const SignatureDelegation = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { Form } = require("react-bootstrap");
  const { register, formState: { errors }, handleSubmit } = useForm();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const signerGUI = location.state.documents.SignerDTO.SignerGUI;
  const documents = location.state.documents;
  const emailId = location.state.emailId;
  const defaultMessage = location.state.signatureDelegationInfo.Message;

  const validateEmail = (value) => {
    if (!value) return false;

    const emailRegex = /^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,3}$/;
    return emailRegex.test(value);
  };

  const sendRequestPersonalData = async (data) => {
    setLoading(true);
    setShowErrorMessage(false);

    const evidenceData = await getEvidenceData();

    const body = {
      ...evidenceData,
      Email: data.email,
      Message: data.message
    };

    SignatureDelegationService.signatureDelegation(signerGUI, body)
      .then(response => {
        setLoading(false);
        const link = "/finalized-process";
        navigate(link);
      })
      .catch(err => {
        console.log(err);
        setErrorMessage(t('general.error_modal'));
        setLoading(false);
        setShowErrorMessage(true);
      });
  }

  const handleBack = () => {
    let link = "/document"

    navigate(link, {
      state: {
        documents: documents,
        emailId: emailId
      }
    });
  };


  return (
    <Container className="container-row row-box form-view">
      <Row>
        <div className="welcome-container">
          <div className="welcome-text-container">
            <Back handleBack={handleBack} />
            <h3 style={{ fontWeight: 800, marginTop: "13px" }}>{t('signature_delegation.title')}</h3>
            <strong><p>{t('signature_delegation.description')}</p></strong>
          </div>
        </div>
        <hr className="welcome-separator" />
      </Row>
      <Row>
        <Form onSubmit={handleSubmit(sendRequestPersonalData)} style={{ paddingLeft: '0px', paddingRight: '0px' }}>
          <div className="textbox-container">
            <label> {t('signature_delegation.email')} *</label>
            <Form.Control
              style={{textAlign: 'left'}}
              type="text"
              {...register('email', {
                required: true,
                maxLength: 255,
                validate: (value) => validateEmail(value),
              })}
            />
            {errors.email?.type === 'required' && <p className="required-field"> {t('signer_data.required_field')} </p>}
            {errors.email?.type === 'maxLength' && <p className="required-field"> {t('signer_data.max_length', { max: 255 })} </p>}
            {errors.email?.type === 'validate' && <p className="required-field"> {t('signature_delegation.email_invalid_format')} </p>}
          </div>
          <div className="textbox-container">
            <label> {t('signature_delegation.message')} *</label>
            <Form.Control
              style={{textAlign: 'left'}}
              type="text"
              {...register('message', { value: defaultMessage, required: true })}
            />
            {errors.message?.type === 'required' && <p className="required-field"> {t('signer_data.required_field')} </p>}
          </div>
          {showErrorMessage &&
            <div className="text-align-start">
              <span className="required-field"> {errorMessage} </span>
            </div>
          }
          <Row className="delegation-button action-buttons mobile-button">
            <Col md={6} lg={6} xs={6}>
              <button type="button" className="btn btn-secondary btn-cancel btn-mobile" onClick={() => handleBack()}>
                <span className="cancel-text">{t('general.cancel')}</span>
                <CancelIcon />
              </button>
            </Col>
            <Col md={6} lg={6} xs={6}>
              <button type="submit" className="btn btn-primary btn-active" disabled={loading}>
                <span className="cancel-text">{t('signature_delegation.delegate')}</span>
                <ArrowIcon />
              </button>
            </Col>
          </Row>
        </Form>
      </Row>
    </Container >
  );
};